import React, { Component } from 'react';

const LoserCross = (props) => {
	const icon_size = 40;
	const padding = 16;

	const view_box = [-padding, -padding, icon_size + 2 * padding, icon_size + 2 * padding];

	return (
		<span class="loser_icon">
			<svg xmlns="http://www.w3.org/2000/svg" height="80%" viewBox={view_box.join(" ")}>
				<g class="loser_cross">
					<line x1={0} y1={icon_size} x2={icon_size} y2={0} class="highlight" />
					<line x1={icon_size} y1={icon_size} x2={0} y2={0} class="highlight" />
					<line x1={0} y1={icon_size} x2={icon_size} y2={0} class="stroke" />
					<line x1={icon_size} y1={icon_size} x2={0} y2={0} class="stroke" />
				</g>
			</svg>
		</span>
	)
};

export default LoserCross;